import { PropsWithChildren } from 'react';
import BookkeepingAside, { BookkeepingAsideState } from '~/components/layout/BookkeepingAside';
import { MIN_REGISTRATION_ASIDE_WIDTH, useAsideWidth } from './utils/RegistrationAsideState';

interface RegistrationAsideProps extends PropsWithChildren {
  asideState: BookkeepingAsideState;
  closeAside: () => void;
}

const RegistrationAside: React.FC<RegistrationAsideProps> = ({ asideState, children, closeAside }) => {
  const [desiredWidth, setDesiredWidth] = useAsideWidth();

  return (
    <BookkeepingAside
      asideState={asideState}
      desiredWidth={desiredWidth}
      minWidth={MIN_REGISTRATION_ASIDE_WIDTH}
      setDesiredWidth={setDesiredWidth}
      closeAside={closeAside}
    >
      {children}
    </BookkeepingAside>
  );
};

export default RegistrationAside;
